<div class="d-flex" [ngClass]="{'member-item-admin-view': isAdminView || isModerator}">
  <div class="avatar rounded-circle">
    <a [profile]="user">
      <app-avatar [src]="user.icon" [placeholder]="user | initials" class="small"></app-avatar>
    </a>
  </div>

  <div class="data">
    <a class="name" [profile]="user"> {{user.name}} </a>

    <div class="type">{{user.type_name}}</div>

    <ng-container *ngIf="isMe === false">
      <div class="link" *ngIf="user.is_friend === false" (click)="onProfileConnect(); false"> Connect +</div>
      <div class="link" *ngIf="user.is_friend === true" (click)="onProfileDisconnect(); false"> Disconnect</div>
    </ng-container>
  </div>

  <div class="rights-position" (click)="onOpen(); false" *ngIf="isAdminView">
    <span *ngIf="isModerator">Moderator</span>
    <span *ngIf="isMember">Member</span>

    <div class="members-arrow" *ngIf="!isMe">
      <svg viewBox="0 0 8 5">
        <use href="#light-gray-down-arrow" />
      </svg>
    </div>

    <div class="members-options-wrap" [ngClass]="{'open': isOpen}">
      <div class="members-options-item" [ngClass]="{'current': isModerator}" (click)="updateToModerator(); false">
        Moderator</div
      >
      <div class="members-options-item" [ngClass]="{'current': isMember}" (click)="updateToMember(); false">Member</div>
    </div>
  </div>

  <div class="rights-position" *ngIf="!isAdminView">
    <span *ngIf="isModerator">Moderator</span>
  </div>
</div>
